import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const PreviewPage = lazy(() => import('../pages/PrismicPreviewPage'));

const routes = [
  {
    title: locationName[Location.PRISMIC_PREVIEW],
    path: Location.PRISMIC_PREVIEW,
    team: 'squad-gf-core',
    component: PreviewPage,
  },
];

export default routes;
